import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { CoreModule } from './core/core.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app.routing';

import { AppComponent } from './app.component';

import { AuthorizationHeaderInterceptor } from './shared/interceptors/auth-header.interceptor';
import { ErrorHandlingInterceptor } from "@app/shared/interceptors/error-handling.interceptor";

import { environment } from 'environments/environment';
import { ForgotPasswordInterceptor } from "@app/authentication/mock/forgot-password.mock";
import { DashboardMockInterceptor } from "@app/dashboard/mocks/dashboard.mock";
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { ToastsManager } from "@app/shared/util/toastr.service";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

// Providers used to create fake backend
let mockProviders: any[] = [];

if (environment.mocks.forgotPassword) {
    mockProviders = [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ForgotPasswordInterceptor,
            multi: true
        }
    ]
}

if (environment.mocks.dashboard) {
    mockProviders = [
        ...mockProviders,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DashboardMockInterceptor,
            multi: true
        }
    ];
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        AuthenticationModule,
        CoreModule,
        SharedModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        StoreModule.forRoot({}, {
            metaReducers: []
        }),
        StoreDevtoolsModule.instrument(),
        EffectsModule.forRoot([]),
    ],
    providers: [
        ...mockProviders,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthorizationHeaderInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorHandlingInterceptor,
            multi: true
        },
        ToastsManager
    ],
    bootstrap: [AppComponent]
})
export class AppModule {

}
